import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import * as firebase from 'firebase';
import swal from 'sweetalert';
import { NotificationsService } from './notifications.service';
@Injectable({
  providedIn: 'root'
})
export class SuperadminService {

  
 constructor(private auth:AngularFireAuth,public db:AngularFirestore,private notification:NotificationsService) { }
   public user
  crearUsuario(i){
    console.log(i)
    
    this.user=this.auth.auth.currentUser
    var cadena:string=i.numero.toString()
    console.log(cadena)
    this.auth.auth.createUserWithEmailAndPassword(i.email,cadena).then(g=>{
        this.db.collection('usuarios').doc(g.user.uid).set({
          apellido:i.apellido,
          datetime:i.datetime,
          email:i.email,
          pais:i.pais,
          estado:i.estado,
          nombre:i.nombre,
          numero:i.numero,
          role:i.role,
          type:i.type,
          oneSigID:i.oneSigID,
          tokenSigID:i.tokenSigID,
          foto:i.foto,
          municipio:i.municipio,
          ciudad:i.ciudad,
          coords:i.coords,
          uid:g.user.uid
        }).then(()=>{
       
          var msg={
            title:"Haz Sido Aprobado!!",
            proveedor:g.user.uid,
            message:"Bienvenido al equipo MAXSELLGLOBAl!! Se ha Verificado Tú Solicitud"
          }
          console.log(msg)

          this.auth.auth.updateCurrentUser(this.user)
           this.db.collection('solicitud_usuario',ref=>ref.where('numero','==',i.numero)).get().subscribe(k=>{
                k.forEach(l=>{
                   l.ref.update({
                    estado:1
                   }).then(()=>{
                    this.notification.sendNotiPushConfirmacionSolicitante(msg)

                    window.location.reload
                   })
                })
           })

        })
    })
  }


 
  initializeFireDev(name,data){
    
    this.db.collection(name).doc(data.uid).set({data})
  }
}
